import React, { lazy, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import SEO from '../components/SEO/SEO'
import { OrganizationSchema } from '../components/SEO/StructuredData'
import Header from '../components/organisms/Header'
import Hero from '../components/organisms/Hero'
import ProjectsGrid from '../components/organisms/ProjectsGrid'
const Footer = lazy(() => import(/* webpackChunkName: "Footer" */ '../components/organisms/Footer'))
import styles from './Home.module.css'

/**
 * Home - Page d'accueil
 * @page
 */
const Home = () => {
  const { t } = useTranslation('home')

  const events = [
    {
      title: t('events.courseOrientation.title'),
      category: t('events.courseOrientation.category'),
      year: '2026',
      color: '#E91E63',
      image: '/voco-2026/voco.webp',
      link: '/actualites/course-orientation-octobre-rose',
    },
    {
      title: t('events.forumAssociations.title'),
      category: t('events.forumAssociations.category'),
      year: '2026',
      color: '#2ECC71',
      image: '/forum-asso/forum-2.webp',
      link: '/actualites/forum-associations',
    },
    {
      title: t('events.finalParthenay.title'),
      category: t('events.finalParthenay.category'),
      year: '2026',
      color: '#4A90D9',
      image: '/tournoi-parthenay/parthenay.webp',
      link: '/tournois/parthenay-2026',
    },
    {
      title: t('events.bagsOnFire.title'),
      category: t('events.bagsOnFire.category'),
      year: '2026',
      color: '#FF8C00',
      image: '/tournoi-bags-on-fire/bagsonfire.webp',
      link: '/tournois/bags-on-fire-2026',
    },
    {
      title: t('events.regionalChampionship.title'),
      category: t('events.regionalChampionship.category'),
      year: '2026',
      color: '#95E1D3',
      image: '/home/calendrier-tournoi.webp',
      link: 'https://www.ofch.fr/actualites/calendrier/',
      external: true,
    },
    {
      title: t('events.summerTournament.title'),
      category: t('events.summerTournament.category'),
      year: '2026',
      color: '#FF6B6B',
      image: '/atv/atv.png',
      link: '/evenements/anime-tes-vacances',
    },
  ]

  return (
    <div className={styles.page}>
      <SEO
        title={t('seo.title')}
        description={t('seo.description')}
        keywords={t('seo.keywords')}
        url="/"
        image="/common/burdigala-logo.webp"
      />
      <OrganizationSchema />
      <Header />
      <main className={styles.main}>
        <Hero />
        <ProjectsGrid
          title={t('eventsSection.title')}
          subtitle={t('eventsSection.subtitle')}
          projects={events}
        />
      </main>
      <Suspense fallback={<div style={{ height: '200px' }} />}>
        <Footer />
      </Suspense>
    </div>
  )
}

export default Home
